var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class=\'inner\'>\n  <h1><a href=\'https://carto.com\' class=\'logo\' id=\'the_logo\'>CARTO</a></h1>\n  <ul class=\'options\'>\n    ';
 if (!username && !isMobileDevice) { ;
__p += '\n      <li><a href=\'https://carto.com/learn/guides\' class=\'guides\'>Guides</a></li>\n    ';
 } ;
__p += '\n\n    ';
 if (!username) { ;
__p += '\n      ';
 if ( !isCartoDBHosted ) { ;
__p += '\n        <li><a class=\'signup\' href=\'https://carto.com/signup\'>Sign up</a><li>\n      ';
 } ;
__p += '\n      <li><a href=\'https://carto.com/login\' class=\'border login\'>Login</a></li>\n    ';
 } else { ;
__p += '\n      <li>\n        <a class=\'editor dropdown account\' href=\'' +
__e( urls[0] ) +
'\'>\n          ';
 if (avatar_url) { ;
__p += '<img src=\'' +
__e( avatar_url ) +
'\' width=\'18\' title=\'' +
__e( username ) +
'\' alt=\'' +
__e( username ) +
'\' />';
 } ;
__p +=
__e( username ) +
'<span class=\'separator\'></span>\n        </a>\n      </li>\n    ';
 } ;
__p += '\n  </ul>\n</div>\n';

}
return __p
}